import "azure-devops-ui/CommonImports";
import "azure-devops-ui/Core/core.css";
import "./Accordion.css";
import * as React from "react";
import { CSSTransitionGroup } from "react-transition-group";
import { getId } from "azure-devops-ui/Core/Util/Object";
import { Button } from "azure-devops-ui/Button";
import { Icon } from "azure-devops-ui/Icon";
import { Observer } from "azure-devops-ui/Observer";
import { Tooltip } from "azure-devops-ui/TooltipEx";
import { css, getSafeId } from "azure-devops-ui/Util";
export class Accordion extends React.Component {
    constructor(props) {
        super(props);
        this.controlId = getId("accordion-section-group-content");
    }
    render() {
        return (React.createElement("div", { className: css("bolt-accordion-section-group", this.props.className) },
            React.createElement(Observer, { sections: this.props.sections }, (sectionProps) => {
                return sectionProps.sections.map((s, index) => this.renderSection(s, index));
            })));
    }
    renderSection(section, index) {
        const itemId = this.controlId + "-" + index;
        return (React.createElement(Observer, { key: section.key, isCollapsed: section.isCollapsed }, (props) => {
            return (React.createElement("div", null,
                React.createElement("span", { className: "flex-row" },
                    React.createElement(Button, { subtle: true, onClick: event => {
                            section.onClick && section.onClick(event);
                            if (!event.isDefaultPrevented()) {
                                this.props.onSectionClicked && this.props.onSectionClicked(event, section);
                            }
                        }, className: "bolt-accordion-section-header flex-grow", ariaExpanded: !props.isCollapsed, ariaControls: !props.isCollapsed ? itemId : undefined },
                        React.createElement("span", { className: "bolt-accordion-section-header-content flex-row flex-grow" },
                            React.createElement(Tooltip, { overflowOnly: true },
                                React.createElement("div", { className: "body-m font-weight-semibold flex-grow text-ellipsis" }, section.title || section.key)),
                            React.createElement(Icon, { iconName: "ChevronDownMed", className: css("bolt-accordion-section-chevron", !props.isCollapsed && "rotate") })))),
                React.createElement(CSSTransitionGroup, { transitionName: "bolt-accordion-section-content", transitionEnter: true, transitionLeave: true, transitionEnterTimeout: 150, transitionLeaveTimeout: 150 }, !props.isCollapsed && (React.createElement("div", { id: getSafeId(itemId), className: "bolt-accordion-section-content" }, section.onRenderContent())))));
        }));
    }
}
